import { HttpClientConfig } from '../../../useHttpClientConfig'
import { Consultant } from '../types'
import { service } from '../service'
import { hydratePathname } from 'util/'

const ApiPathname = {
  CONSULTANT: '/sales/v1/consultants/:consultantGid',
} as const

const makeGetConsultant =
  (baseUrl: string, config: HttpClientConfig) =>
  async (consultantGid: string): Promise<Consultant> => {
    const pathname = hydratePathname(ApiPathname.CONSULTANT, { consultantGid })

    const { data } = await service(baseUrl).get<Consultant>(pathname, {
      ...config,
    })

    return data
  }

export { makeGetConsultant }
